import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar, PriceCard } from '../components';
import { Typography } from '@material-tailwind/react';
import APRPLogo from "../assets/images/APRPLogo.png"
import DXCLogo from "../assets/images/sponsors/DXC Logo_Purple+Black RGB.png"
import TeromovigoLogo from "../assets/images/sponsors/teromovigo-logo-color.svg"
import AmiSantosLogo from "../assets/images/sponsors/amiSantos.jpg"

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const BRONZE_TIER = {
  price: 500,
  benefits: [
    "Sponsor's logo (Small size) on the event website.",
    "Logo and name of the conference book sponsor (Interior)",
  ]
}

const SILVER_TIER = {
  price: 1000,
  benefits: [
    "Sponsor's logo (Small size) on the event website.",
    "Logo and name of the conference book sponsor (Interior)",
    "Fixed advertising panel (Small panel) in a prominent place at the event.",
    "Advertising slides projected on a loop during the event.",
  ]
}

const GOLD_TIER = {
  price: 1500,
  benefits: [
    "Sponsor promotional material in the gift pack.",
    "Company logo on conference publicity material.",
    "Sponsor's logo (Medium size) on the event website.",
    "Logo and name of the conference book sponsor (Interior)",
    "Fixed advertising panel (Medium panel) in a prominent place at the event.",
    "Advertising slides projected on a loop during the event.",
  ]
}

const PLATINUM_TIER = {
  price: 2000,
  benefits: [
    "Registration and social programme for two sales representatives",
    "Sponsor promotional material in the gift pack.",
    "Company logo on conference publicity material.",
    "Sponsor's logo (Large size) on the event website.",
    "Logo and name of the conference book sponsor (Cover)",
    "Fixed advertising panel (Large panel) in a prominent place at the event.",
    "Advertising slides projected on a loop during the event.",
    "Advertising video projected on a loop during the event",
  ]
}

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={3}
      stroke="currentColor"
      className="h-3 w-3"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 12.75l6 6 9-13.5"
      />
    </svg>
  );
}


export function SponsorshipPackages() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openUrl = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <div className="w-full  relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Sponsorship"} />

        <section className="w-full container mx-auto py-12 px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Sponsors
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              RECPAD is proudly supported by our esteemed sponsors and partners, whose generous contributions are essential to the organization and success of this important event.
            </Typography>
            <Typography variant="h5" color="blue-gray" className="mt-4">
              Our Main Sponsor
            </Typography>
            <div className="w-full flex  px-4 gap-12 mt-2" >
              {/* <img onClick={() => openUrl("https://aprp.pt/en/home/")} className="h-12 cursor-pointer" src={APRPLogo} alt="APRP" /> */}
              <img onClick={() => openUrl("https://dxc.com")} className="h-36 cursor-pointer" src={DXCLogo} alt="APRP" />
            </div>
            <Typography color="gray" className="font-normal">
              We are especially grateful to <strong>DXC Technology </strong> for their outstanding support, which has played a vital role in the success of RECPAD.
            </Typography>

            <Typography variant="h5" color="blue-gray" className="mt-4">
              Other Sponsors
            </Typography>

            <div className="w-full flex items-center flex-col lg:flex-row gap-8 lg:gap-16 mt-8" >
              <img onClick={() => openUrl("https://teromovigo.com/")} className="h-12 cursor-pointer" src={TeromovigoLogo} alt="APRP" />
              <img onClick={() => openUrl("https://www.facebook.com/p/Ami-Santos-100063679533180")} className="h-20 cursor-pointer" src={AmiSantosLogo} alt="APRP" />
            </div>

            <Typography color="gray" className="font-normal mt-6 lg:mt-4">
              We also deeply value the contributions of <strong>TeroMovigo </strong> and <strong>AmiSantos</strong>, whose support helps foster collaboration and knowledge-sharing within the scientific community.
            </Typography>

            <Typography color="gray" className="font-normal mt-4">
              We are also deeply grateful to <strong>APRP</strong>, for their financial contribution of <strong>500€</strong>, which has been instrumental in aiding the organization of RECPAD.
            </Typography>


            <Typography color="gray" className="font-normal mt-4">
              RECPAD attracts over 70 participants from across Portugal in the fields of <strong>Pattern Recognition</strong>, <strong>Image Analysis and Processing</strong>, and related areas. The event features invited talks, poster presentations, and ample networking opportunities, offering sponsors valuable exposure to an engaged scientific audience.

            </Typography>

            {/* <Typography color="gray" className="font-normal mt-2">
              With 70+ participants from all over Portugal, RECPAD is a one-day event, aimed at promoting cooperation and
              exchange among the Portuguese scientific community in the fields of <strong>Pattern Recognition</strong>, <strong>Image Analysis and Processing</strong>,
              <strong> Soft Computing</strong>, and related areas.
            </Typography> */}

            {/* <Typography color="gray" className="font-normal mt-2">
              Featuring two invited talks, many poster presentations, and several networking opportunities throughout the day, RECPAD is thus an excellent venue for showcasing your research and products in any of the above fields.
            </Typography> */}

          </div>

        </section>

        {/* <section className="w-full mx-auto py-4 px-14 flex justify-center" >
          <div className="grid grid-cols-1 gap-x-6 gap-y-6 lg:grid-cols-2 xl:grid-cols-4 sm:gap-y-4 lg:gap-x-2  items-start justify-center relative z-10">
            <PriceCard tier="BRONZE" benefits={BRONZE_TIER.benefits} price={BRONZE_TIER.price} >
              <ul className="flex flex-col gap-2">
                {BRONZE_TIER.benefits.map((i) => (
                  <li className={classNames(
                    "flex items-center gap-4",
                    "opacity-100"
                  )}>
                    <span className={classNames(
                      "rounded-full border border-white/20 bg-white/20 p-1",
                      "bg-white/40"
                    )}>
                      <CheckIcon />
                    </span>
                    <Typography className="font-normal text-sm">{i}</Typography>
                  </li>
                ))}
              </ul>
            </PriceCard>
            <PriceCard tier="SILVER" benefits={SILVER_TIER.benefits} price={SILVER_TIER.price} >
              <ul className="flex flex-col gap-2">
                {SILVER_TIER.benefits.map((i) => (
                  <li className={classNames(
                    "flex items-center gap-4",
                    "opacity-100"
                  )}>
                    <span className={classNames(
                      "rounded-full border border-white/20 bg-white/20 p-1",
                      "bg-white/40"
                    )}>
                      <CheckIcon />
                    </span>
                    <Typography className="font-normal text-sm">{i}</Typography>
                  </li>
                ))}
              </ul>
            </PriceCard>

            <PriceCard tier="GOLD" benefits={GOLD_TIER.benefits} price={GOLD_TIER.price} >
              <ul className="flex flex-col gap-2">
                {GOLD_TIER.benefits.map((i) => (
                  <li className={classNames(
                    "flex items-center gap-4",
                    "opacity-100"
                  )}>
                    <span className={classNames(
                      "rounded-full border border-white/20 bg-white/20 p-1",
                      "bg-white/40"
                    )}>
                      <CheckIcon />
                    </span>
                    <Typography className="font-normal text-sm">{i}</Typography>
                  </li>
                ))}
              </ul>
            </PriceCard>
            <PriceCard tier="PLATINUM" benefits={PLATINUM_TIER.benefits} price={PLATINUM_TIER.price}  >
              <ul className="flex flex-col gap-2">
                {PLATINUM_TIER.benefits.map((i) => (
                  <li className={classNames(
                    "flex items-center gap-4",
                    "opacity-100"
                  )}>
                    <span className={classNames(
                      "rounded-full border border-white/20 bg-white/20 p-1",
                      "bg-white/40"
                    )}>
                      <CheckIcon />
                    </span>
                    <Typography className="font-normal text-sm">{i}</Typography>
                  </li>
                ))}
              </ul>
            </PriceCard>
          </div>
        </section> */}


        <Footer />

      </div>
    </>
  );
}
